import React, { useState, useContext, useEffect } from "react";
import {
  Container,
  Form,
  Button,
  Card,
  Row,
  Col,
  Image,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Bg from "../gif/bg.jpg";
import axios from "axios";
import Loader from "../gif/loader.gif";
import "../css/timer.css";
import Logo from "../gif/logo.png";
//get context
import { context } from "../App";

const LoginTest = () => {
  //
  const [cell, setCell] = useState();
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState(false);
  // Destructure the context as an array
  const [signIn, setSignIn] = useContext(context);
  //
  const [timeLeft, setTimeLeft] = useState({});
  const [sundayDate, setSundayDate] = useState();
  const [todayIsSunday, setTodayIsSunday] = useState(false);
  const [today, setToday] = useState();

  const login = async (e) => {
    e.preventDefault();
    setLoading(!loading);
    let url = `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-login?cell=${cell}&password=${password}`;

    try {
      const res = await axios.get(url);
      // let retcode = res.data;
      const data = res.data;
      setSignIn(true);
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      alert("Login failed, verify your cell number and password");
      console.log("get login error =>" + error);
    }
  };
  // Function to format date in a readable format (e.g., Sunday, December 15, 2024)
  const formatDate = (date) => {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString(undefined, options);
  };
  //function to check if today is sunday
  const isTodaySunday = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    //console.log("day of the week", dayOfWeek);
    if (dayOfWeek === 0) {
      return true;
    }
    return false;
  };
  //Function to get the next Sunday's date
  const getNextSunday = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const daysUntilSunday = 7 - dayOfWeek;
    const nextSunday = new Date(today);
    nextSunday.setDate(today.getDate() + daysUntilSunday);
    nextSunday.setHours(0, 0, 0, 0); // Reset time to midnight
    return nextSunday;
  };
  // Function to calculate the time left until next Sunday
  const calculateTimeLeft = () => {
    const nextSunday = getNextSunday();
    const difference = nextSunday - new Date();

    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };
  //
  useEffect(() => {
    const retValue = isTodaySunday();
    //console.log(retValue);
    if (retValue) {
      const today = new Date();
      setToday(formatDate(today));
      setTodayIsSunday(true);
    } else {
      setTodayIsSunday(false);
      const nextSunday = getNextSunday();
      setSundayDate(formatDate(nextSunday)); // Set next Sunday date in readable format

      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);

      return () => clearInterval(timer);
    }
  }, []);
  return (
    <div
      style={{
        backgroundImage: `url(${Bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        justifyContent: "flex-start", // Changed from 'center' to 'flex-start'
        paddingLeft: "50px", // Add some padding so it's not flush against the edge
      }}
    >
      <Container>
        {/* className="justify-content-center" */}
        <Row>
          <Col md={6} lg={4} sm={8}>
            <Card
              style={{
                borderRadius: "15px",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
                opacity: "0.95",
              }}
            >
              <Card.Body className="p-4">
                <div className="text-center mb-4">
                  <Image
                    src={Logo}
                    roundedCircle
                    alt="Profile"
                    style={{
                      width: "120px",
                      height: "120px",
                      marginTop: "-20%",
                    }}
                  />
                  <p className="text-muted">Welcome Back!</p>
                  <p>Sign in to continue to NTC Church.</p>
                </div>

                <Form onSubmit={login}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter cell number"
                      className="py-2"
                      value={cell}
                      onChange={(e) => setCell(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter password"
                      className="py-2"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100 py-2 mb-3"
                    style={{
                      backgroundColor: "#7CA721",
                      borderColor: "#7CA721",
                    }}
                  >
                    {loading ? (
                      <img
                        src={Loader}
                        alt="QR Code"
                        width={"40"}
                        height={"40"}
                        className="img-fluid text-white"
                        style={{ alignSelf: "center" }}
                      />
                    ) : (
                      "Log In"
                    )}
                  </Button>

                  <div className="text-center mb-3">
                    <a href="#forgot" className="text-decoration-none">
                      Forgot your password?
                    </a>
                  </div>
                </Form>
                <div className="text-center mt-4">
                  <p
                    className="text-muted"
                    style={{ fontSize: 12, fontWeight: "bold" }}
                  >
                    Next{" "}
                    <a href="#register" className="text-decoration-none">
                      NTC Church
                    </a>{" "}
                    service in:
                  </p>
                  <div className="timer-container">
                    <div className="timer-display">
                      <span className="time-value">{timeLeft.days}</span> Days{" "}
                      <span className="time-value">{timeLeft.hours}</span> Hours{" "}
                      <span className="time-value">{timeLeft.minutes}</span> Min{" "}
                      <span className="time-value">{timeLeft.seconds}</span> Sec
                    </div>
                  </div>
                  <p className="text-muted small mt-4" style={{ fontSize: 12 }}>
                    © 2025 NTC Church. Crafted with ♥ by OTG
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoginTest;
